import type { Theme } from '@mui/material';

export const styles = {
  breakDropTarget: (canDrop: boolean, isOver: boolean) => (theme: Theme) => {
    if (canDrop) {
      if (isOver) {
        return { color: theme.colors.green[600] };
      }
      return { color: theme.colors.neutral[500] };
    }
    return { color: theme.colors.neutral[300] };
  },
};
